import { BaseModel } from "../base/base.model";

export class RecurringJob extends BaseModel{
  Cron: string;
  Queue: string;
  NextExecution: string | null;
  LastJobId: string;
  LastJobState: string;
  LastExecution: string | null;
  CreatedAt: string | null;
  Removed: boolean;
  TimeZoneId: string;
  Error: string;
  RetryAttempt: number;

  get Name(){
    if(this.Id != null && this.Id != undefined)
    {
      const id = this.Id.toString();
      const index = id.indexOf('_');
      if(index > 0)
        return id.substring(0,index);
      return id;
    }
    return '';

  }

}
